import { PartnerContact } from '@/components/common/contact_components/PartnerContact';
import { AddressProps } from '@/models/Address';
import { ContactProps, ContactType } from '@/models/Contact';

export function ShippingAddressSection({
  shippingContact,
  shippingContactType,
  showErrors,
  onChange,
}: {
  shippingContact: ContactProps;
  shippingContactType?: ContactType;
  showErrors: boolean;
  onChange: (address: AddressProps) => void;
}) {
  return (
    <PartnerContact
      id={`shipping-contact-${shippingContact?.id}`}
      contact={shippingContact}
      contactType={shippingContactType}
      onChange={onChange}
      showErrors={showErrors}
    />
  );
}
